import React, { useEffect, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { Form, Input, Select, Skeleton } from 'antd'
import { useQuery } from 'react-query'
import { isEmpty } from 'lodash-es'

const useWATemplate = ({ enabled, fetcher, key }) => {
  return useQuery(
    [key],
    async () => {
      const {
        data: { data },
      } = await fetcher()
      return data
    },
    { enabled },
  )
}

const PersonalWhatsapp = ({ getWaTemplate, waTemplateKey, show }) => {
  const { formatMessage } = useIntl()
  const form = Form.useFormInstance()

  const { data: waTemplate, isLoading: loadingWaTemplate } = useWATemplate({
    enabled: show,
    fetcher: getWaTemplate,
    key: waTemplateKey,
  })

  const formattedWaTemplate = useMemo(() => {
    if (!waTemplate) {
      return {}
    }

    let phones = []

    if (!isEmpty(waTemplate.phones)) {
      phones = waTemplate.phones.filter(Boolean)
    }

    return {
      phoneNumbers: phones.map((phoneNumber) => ({
        label: phoneNumber,
        value: phoneNumber,
      })),
      phones,
      body: waTemplate.body,
      phone: waTemplate.phone,
    }
  }, [waTemplate])

  useEffect(() => {
    if (show && !isEmpty(waTemplate)) {
      form.setFieldValue('body', formattedWaTemplate.body)

      if (!isEmpty(formattedWaTemplate.phones)) {
        form.setFieldValue('phone_number', formattedWaTemplate.phones[0])
      } else if (!isEmpty(formattedWaTemplate.phone)) {
        form.setFieldValue('phone_number', formattedWaTemplate.phone)
      }
    }
  }, [
    show,
    form,
    formattedWaTemplate.phone,
    waTemplate,
    formattedWaTemplate.body,
    formattedWaTemplate.phones,
  ])

  return (
    <Skeleton loading={loadingWaTemplate} active>
      <Form.Item
        label={formatMessage({ id: 'sms.destination_number' })}
        name="phone_number"
        rules={[
          { required: true, message: formatMessage({ id: 'sms.please_input_phone' }) },
          {
            min: 6,
            message: formatMessage({ id: 'financeContacts.min_characters' }, { value: 6 }),
          },
          {
            pattern: /^[\d\+]+$/,
            message: formatMessage({ id: 'financeContacts.only_number_allowed' }),
          },
        ]}
      >
        {formattedWaTemplate.phones?.length < 2 ? (
          <Input placeholder={formatMessage({ id: 'sms.destination_number' })} />
        ) : (
          <Select
            placeholder="Select a option and change input text above"
            options={formattedWaTemplate.phoneNumbers || []}
          />
        )}
      </Form.Item>
      <Form.Item
        label={formatMessage({ id: 'sms.wa_content' })}
        name="body"
        rules={[
          {
            required: true,
            message: formatMessage({ id: 'sms.please_input_wa_content' }),
          },
          {
            min: 20,
            message: formatMessage({ id: 'financeContacts.min_characters' }, { value: 20 }),
          },
        ]}
      >
        <Input.TextArea
          placeholder={formatMessage({ id: 'sms.wa_content' })}
          autoSize={{ minRows: 2, maxRows: 8 }}
        />
      </Form.Item>
    </Skeleton>
  )
}

export default PersonalWhatsapp
